import { useWorld } from './use-world'
import { GRID_SIZE } from '../config/constants'

export const useCollision = () => {
  const { container, spritesRef, solidGridRef, npcGridRef } = useWorld()

  const isInViewport = (obj) => {
    return (
      obj.y >= 0 &&
      obj.x >= 0 &&
      obj.x + obj.width <= container.width &&
      obj.y + obj.height <= container.height
    )
  }

  const doObjectsCollide = (box1, box2) => {
    if (!box1 || !box2) return false
    return (
      box1.x < box2.x + box2.width &&
      box1.x + box1.width > box2.x &&
      box1.y < box2.y + box2.height &&
      box1.y + box1.height > box2.y
    )
  }

  // O(1) neighborhood lookup via solidGridRef spatial index.
  // Checks the 3×3 cell neighborhood, which covers all GRID_SIZE sprites that could overlap obj.
  const isColliding = (obj) => {
    if (!isInViewport(obj)) return true
    const sprites = spritesRef.current
    const grid = solidGridRef.current
    const col = Math.floor(obj.x / GRID_SIZE)
    const row = Math.floor(obj.y / GRID_SIZE)
    for (let dc = -1; dc <= 1; dc++) {
      for (let dr = -1; dr <= 1; dr++) {
        const ids = grid[`${col + dc},${row + dr}`]
        if (!ids) continue
        for (const id of ids) {
          if (id === obj.id) continue
          const s = sprites[id]
          if (s && doObjectsCollide(obj, s.position)) return s
        }
      }
    }
    return false
  }

  // O(1) neighborhood lookup via npcGridRef spatial index.
  const isInteracting = (obj) => {
    const collisions = []
    const sprites = spritesRef.current
    const grid = npcGridRef.current
    const col = Math.floor(obj.x / GRID_SIZE)
    const row = Math.floor(obj.y / GRID_SIZE)
    for (let dc = -1; dc <= 1; dc++) {
      for (let dr = -1; dr <= 1; dr++) {
        const ids = grid[`${col + dc},${row + dr}`]
        if (!ids) continue
        for (const id of ids) {
          if (id === obj.id) continue
          const sprite = sprites[id]
          if (sprite && doObjectsCollide(obj, sprite.position)) collisions.push(sprite)
        }
      }
    }
    return collisions
  }

  return { isColliding, isInteracting, doObjectsCollide }
}
